/* eslint-disable react/prop-types */
import React from 'react';

import { usePage, useMedia } from '@api/hooks';
import config from '@config';
import { InfoItem } from '@molecules';
import { appendSlug } from '@utils';

const LinkItem = ({ link }) => {
  const { page, ...pageQuery } = usePage({ id: link.pageId });
  const { media, ...mediaQuery } = useMedia({ id: link.fileId });
  let description = link.url;

  if (link.pageId) {
    description =
      (pageQuery.isLoading && 'Loading ...') || pageQuery.error?.message || appendSlug(config.website.url, page.slug);
  }

  if (link.fileId) {
    description = (mediaQuery.isLoading && 'Loading ...') || mediaQuery.error?.message || media.src;
  }

  return <InfoItem description={description}>{link.name}</InfoItem>;
};

export default LinkItem;
